import React from 'react';
import { string, node, oneOfType, arrayOf, bool, number, object } from 'prop-types';
import { Box, Flex } from 'rebass';
/* eslint-disable import/no-cycle */
import PageHeader from './PageHeader';

const Page = ({
  alwaysShowHeader,
  title,
  totalCount,
  HeaderContent,
  children,
  linkBack,
  noPadding,
  noExtraPadding,
  ...rest
}) => {
  const boxStyles = noExtraPadding ? {} : { bg: '#f5f5f5', height: '100%', p: '20px', pb: '40px' };

  return (
    <Flex flexDirection='column' height='100%' width='100%' {...rest}>
      <PageHeader title={title} HeaderContent={HeaderContent} linkBack={linkBack} alwaysShowHeader={alwaysShowHeader} />
      <Box {...boxStyles}>
        {title === 'Catalogs' || title === 'Product Contract Groups' || title === 'Products' ? (
          <Box pb='8px'>{totalCount} results</Box>
        ) : (
          !noPadding && <Box pb='20px' />
        )}
        <Box bg='#fff' height='100%'>
          {children}
        </Box>
      </Box>
    </Flex>
  );
};

Page.defaultProps = {
  HeaderContent: null,
  alwaysShowHeader: false,
  noPadding: false,
  noExtraPadding: false,
  linkBack: {},
  totalCount: 0
};

Page.propTypes = {
  HeaderContent: oneOfType([arrayOf(node), node]),
  alwaysShowHeader: bool,
  children: oneOfType([arrayOf(node), node]).isRequired,
  linkBack: object,
  noPadding: bool,
  noExtraPadding: bool,
  title: string.isRequired,
  totalCount: number
};

export default Page;
